module.exports = __webpack_public_path__ + "static/media/bg.31097182.jpg";